export class ResourceDataItem<T = any>{
  constructor(
    public resource: T,
    public resourceType: string
  ){}
}
